import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Stack,
  Typography,
} from '@worthy-npm/worthy-common-ui-components';
import { StepProps } from '../common';
import { Step, StepContainer, StepGridContainer } from '../../../styles/common';
import StepTitle from '../../stepTitle';
import ShippingStepper from '../../scheduleShipping/shippingStepper';
import {
  getScheduleSuccess,
  getShippingMethod,
} from '../../../slices/schedulingSlice';
import { useAppSelector } from '../../../app/hooks';
import TrustSection from '../../scheduleShipping/TrustSection';
import { selectItemDescription, selectItemPublicId } from '../../../slices/submitSlice';
import GA from '../../../data/GA';
import { redirectToMyItems } from '../../../lib/redirectUtils';

function StepShipping({
  prev, title, props, next, stepName, active,
}: StepProps) {
  const shippingMethod = useAppSelector(getShippingMethod);
  const scheduleSuccess = useAppSelector(getScheduleSuccess);
  const itemDescription = useAppSelector(selectItemDescription);
  const itemPublicId = useAppSelector(selectItemPublicId);

  useEffect(() => {
    if (!active) return;
    GA.schedulingInsertInfoStepView(shippingMethod);
  }, [active, stepName, shippingMethod]);

  const handleNext = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    GA.schedulingInsertInfoStepNext(shippingMethod);
    redirectToMyItems(itemPublicId as string);
  };

  return (
    <StepContainer data-automation="shipping-address-step">
      <Step>
        <StepTitle
          stepCaption={shippingMethod}
          prev={prev}
          stepTitle={title || ''}
          stepNotice=""
          optionalProps={props || {}}
        />
        <StepGridContainer style={{ maxWidth: '560px' }}>
          <Stack gap={2} alignItems="center" justifyContent="center">
            <Stack gap={1}>
              <Typography variant="body1" color="secondary">
                Your:
                {' '}
                {itemDescription}
              </Typography>
            </Stack>
            <>
              <ShippingStepper prev={prev as any} />
              <Stack gap={1} mt={5} maxWidth={320} width="100%">
                <Button
                  variant="contained"
                  color="highlight"
                  fullWidth
                  disableElevation
                  onClick={handleNext}
                  disabled={!scheduleSuccess}
                >
                  {`Confirm ${shippingMethod}`}
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  fullWidth
                  sx={{
                    borderWidth: 2,
                    borderColor: 'primary.main',
                    '&:hover': {
                      borderWidth: 2,
                      borderColor: 'primary.main',
                    },
                  }}
                  onClick={(e) => {
                    GA.schedulingInsertInfoStepSkip();
                    next(e);
                  }}
                >
                  I&apos;ll schedule shipping later
                </Button>
              </Stack>
            </>
          </Stack>
          <Box mt={6}>
            <TrustSection />
          </Box>
        </StepGridContainer>
      </Step>
    </StepContainer>
  );
}

export default StepShipping;
